import Icon from 'veui/components/Icon'
import { IconArrowLeftSolid } from 'dls-icons-vue'

Icon.register('arrow-left-solid', IconArrowLeftSolid)
